package com.schoolconnect.app.datasource.network

import com.schoolconnect.app.datasource.APP_STORAGE_PREFIX
import com.russhwolf.settings.Settings
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

@OptIn(ExperimentalEncodingApi::class)
internal object TokenStore {
    private const val ACCESS_KEY = "${APP_STORAGE_PREFIX}access_token"
    private const val REFRESH_KEY = "${APP_STORAGE_PREFIX}refresh_token"
    private const val TOKEN_TYPE_KEY = "${APP_STORAGE_PREFIX}token_type"
    private const val CRYPTO_KEY = "iSchoolConnect-token-v1"

    private val settingsOrNull: Settings? by lazy(LazyThreadSafetyMode.SYNCHRONIZED) {
        runCatching { Settings() }.getOrNull()
    }
    private var cachedAccessToken: String? = null
    private var cachedRefreshToken: String? = null
    private var cachedTokenType: String? = null

    fun getAccessToken(): String {
        cachedAccessToken?.let { return it }
        val token = decrypt(settingsOrNull?.getString(ACCESS_KEY, "").orEmpty())
        cachedAccessToken = token
        return token
    }

    fun getRefreshToken(): String {
        cachedRefreshToken?.let { return it }
        val token = decrypt(settingsOrNull?.getString(REFRESH_KEY, "").orEmpty())
        cachedRefreshToken = token
        return token
    }

    fun getTokenType(): String {
        cachedTokenType?.let { return it }
        val tokenType = settingsOrNull?.getString(TOKEN_TYPE_KEY, "").orEmpty()
        cachedTokenType = tokenType
        return tokenType
    }

    fun getAuthorizationHeaderValue(): String {
        val token = getAccessToken()
        return if (token.isBlank()) {
            ""
        } else {
            "Bearer $token"
        }
    }

    fun setTokens(accessToken: String, refreshToken: String = "", tokenType: String = "bearer") {
        cachedAccessToken = accessToken.trim()
        cachedRefreshToken = refreshToken.trim()
        cachedTokenType = tokenType.trim()
        settingsOrNull?.putString(ACCESS_KEY, encrypt(cachedAccessToken.orEmpty()))
        settingsOrNull?.putString(REFRESH_KEY, encrypt(cachedRefreshToken.orEmpty()))
        settingsOrNull?.putString(TOKEN_TYPE_KEY, cachedTokenType.orEmpty())
    }

    fun clear() {
        cachedAccessToken = null
        cachedRefreshToken = null
        cachedTokenType = null
        settingsOrNull?.remove(ACCESS_KEY)
        settingsOrNull?.remove(REFRESH_KEY)
        settingsOrNull?.remove(TOKEN_TYPE_KEY)
    }

    private fun encrypt(value: String): String {
        if (value.isBlank()) return ""
        val input = value.encodeToByteArray()
        val key = CRYPTO_KEY.encodeToByteArray()
        val out = ByteArray(input.size)
        for (index in input.indices) {
            out[index] = (input[index].toInt() xor key[index % key.size].toInt()).toByte()
        }
        return Base64.Default.encode(out)
    }

    private fun decrypt(value: String): String {
        if (value.isBlank()) return ""
        return runCatching {
            val input = Base64.Default.decode(value)
            val key = CRYPTO_KEY.encodeToByteArray()
            val out = ByteArray(input.size)
            for (index in input.indices) {
                out[index] = (input[index].toInt() xor key[index % key.size].toInt()).toByte()
            }
            out.decodeToString()
        }.getOrDefault("")
    }
}
